import { Expose, Transform } from 'class-transformer'
import { map } from 'lodash'
import type { paginationMeta as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'

export type SerializedPaginationMeta = Model
interface Links {
    url?: string | null
    label?: string
    active?: boolean
}

export default class PaginationMeta implements CamelCaseKeys<SerializedPaginationMeta> {
    @Expose({ name: 'current_page' })
    currentPage!: Model['current_page']

    from!: Model['from']

    @Expose({ name: 'last_page' })
    lastPage!: Model['last_page']

    @Transform(({ value }) => map(value, ({ url, label, active }: Links) => ({ url, label, active })), {
        toClassOnly: true
    })
    links!: Model['links']

    path!: Model['path']

    @Expose({ name: 'per_page' })
    perPage!: Model['per_page']

    to!: Model['to']

    total!: Model['total']

    constructor(values: PaginationMeta) {
        Object.assign(this, values)
    }
}
